module.exports = __webpack_public_path__ + "img/vertical_4_2_8017.a6df4a74.png";